import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery } from '@tanstack/react-query';
import { TeamMonthlyResultResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  year: number;
  month?: number;
};

const getTeamMonthlyResults = async (params: Params): Promise<TeamMonthlyResultResponse> => {
  const { data } = await api.get<TeamMonthlyResultResponse>(
    `${BI_BASE_URL}/managers/team/monthly/results`,
    { params }
  );

  return data ?? [];
};

export const useGetTeamMonthlyResults = ({ year, month }: Params) => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.TEAM_MONTHLY_RESULTS, year, month],
    queryFn: () => {
      return getTeamMonthlyResults({ year, month });
    },
  });
};
